import React from 'react';

import editorLayoutList from '../../../config/richTextConfig/questionLayout';
const centeredQuestion = Component => props => (
  <Component layout={editorLayoutList.centered} {...props} />
);

export default centeredQuestion;
